import qetaPlugin from '@drodil/backstage-plugin-qeta';
import { QetaPageIntroElementBlueprint } from '@drodil/backstage-plugin-qeta-react';
import {
  coreExtensionData,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';
import { QetaIntroButtons } from '../components/qeta/QetaIntroButtons';
import { QetaPageWithHeader } from '../components/qeta/QetaPageWithHeader';

/**
 * Combined intro buttons (Feedback + Bulk Import) rendered via QetaPageIntroElementBlueprint.
 * Appears on the Q&A page with both action buttons side by side.
 */
const qetaIntroElement = QetaPageIntroElementBlueprint.make({
  params: {
    element: <QetaIntroButtons />,
  },
});

/**
 * The qeta plugin auto-registers its own EntityContentBlueprint ('entity-posts-content')
 * for entity page Q&A tabs. We disable it here because we register our own custom
 * qetaEntityContent blueprint in entityContentExtensionsModule instead.
 */
const disablePluginEntityQaTab = qetaPlugin
  .getExtension('entity-content:qeta/entity-posts-content')
  .override({ disabled: true });

/**
 * Replaces the plugin header toolbar with the themed banner (title, guide button,
 * Teams mute toggle) that the Q&A page had before qeta 4.
 */
const qetaPage = qetaPlugin.getExtension('page:qeta').override({
  *factory(originalFactory) {
    const outputs = originalFactory({
      params: { title: 'Questions', noHeader: true },
    });
    for (const output of outputs) {
      if (output.id === coreExtensionData.reactElement.id) {
        yield coreExtensionData.reactElement(
          <QetaPageWithHeader>{output.value as JSX.Element}</QetaPageWithHeader>,
        );
      } else {
        yield output;
      }
    }
  },
});

const qetaFeature: FrontendFeature = qetaPlugin.withOverrides({
  extensions: [qetaIntroElement, qetaPage, disablePluginEntityQaTab],
});

export default qetaFeature;
